import { render } from "./app-header-account-sets.vue?vue&type=template&id=780e12c4"
import script from "./app-header-account-sets.vue?vue&type=script&lang=js"
export * from "./app-header-account-sets.vue?vue&type=script&lang=js"

import "./app-header-account-sets.vue?vue&type=style&index=0&id=780e12c4&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__